var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChartDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5281 7L7.80531 7C7.14835 7 6.80423 6.19021 7.27349 5.72303L8.30585 4.69522L6.02213 2.42158L3.70713 4.69522C3.33173 5.10011 2.67477 5.10011 2.29936 4.69522L0.140777 2.54616C-0.0469261 2.35929 -0.0469262 2.04783 0.140777 1.86096L0.860304 1.14461C1.04801 0.957732 1.36085 0.957732 1.54855 1.14461L3.01889 2.57731L5.30261 0.303671C5.67801 -0.101223 6.33497 -0.101223 6.71038 0.303671L9.71363 3.29366L10.746 2.26585C11.2152 1.79867 11.9973 2.14127 11.9973 2.79533L11.9973 6.50167C12.0286 6.75083 11.7784 7 11.5281 7Z",
    fill: "#C71A3C"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartDown);
export default __webpack_public_path__ + "static/media/chart-down.aeb5dad61c87652d0fb8305484f0523c.svg";
export { ForwardRef as ReactComponent };